module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "ebook4252-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN para-style-override-10",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('span', {
    staticClass: "char-style-override-12"
  }, [_vm._v("Every time you name yourself,")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-para para-style-override-11"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("you name someone else.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-12"
  }, [_c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("Bertolt Brecht")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-13"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("How can I speak of love, of your Kingdom’s tender hills,")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-14"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("when I live like a cat on a pole surrounded by water?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-14"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("How can I call the hair, hair")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-14"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("the tooth, tooth")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-14"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("the tail, tail")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-14"
  }, [_c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v("and not ever name the rat?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT para-style-override-15"
  }, [_c('span', {
    staticClass: "char-style-override-14"
  }, [_vm._v("Antonio Cisneros, “Oración”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d2484f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ebook4252-5.vue
// module id = 75
// module chunks = 0